module.exports = __webpack_public_path__ + "static/media/ClubHooks_Shield.856b30f6.png";